import { render } from "./standardisationTable.vue?vue&type=template&id=d3ee4008&scoped=true"
import script from "./standardisationTable.vue?vue&type=script&lang=js"
export * from "./standardisationTable.vue?vue&type=script&lang=js"

import "./standardisationTable.vue?vue&type=style&index=0&id=d3ee4008&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3ee4008"]])

export default __exports__